import EChartsReact from 'echarts-for-react'
import { observer } from 'mobx-react-lite'
import React, { useMemo } from 'react'

export default observer(function Mentions({ currentAuthentication }) {

  const authenticationsMentions = useMemo(() => currentAuthentication.authentications_mentions, [currentAuthentication.authentications_mentions, currentAuthentication.authentications_mentions.length])
  const mentionNames = useMemo(() => authenticationsMentions.map((authenticationsMention) => `@${authenticationsMention.mention.name}`), [authenticationsMentions, authenticationsMentions.length])
  const percentages = useMemo(() => authenticationsMentions.map((authenticationsMention) => authenticationsMention.percentage), [authenticationsMentions, authenticationsMentions.length])

  const option = useMemo(() => ({
    xAxis: {
      axisLabel: {
        interval: 0,
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: false
      },
    },
    yAxis: {
      axisLabel: {
        interval: 0,
      },
      data: mentionNames,
      inverse: true,
      type: 'category',
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: false
      }
    },
    series: [
      {
        data: percentages,
        type: 'bar',
        itemStyle: {
          barBorderRadius: [0, 10, 10, 0],
          borderWidth: 1,
          borderType: 'solid',
          borderColor: '#2CCDB4',
          color: '#2CCDB4'
        },
      }
    ],
    grid: {
      containLabel: true
    },
      axisLabel: {
        interval: 0,
      },
    tooltip: {
      trigger: 'item',
      formatter: '{c}%'
    },
    textStyle: {
      fontSize: 10,
      fontWeight: 'bold'
    }
  }), [mentionNames])

  return (
    <div className="w-full bg-white dark:bg-rb-dark-mode rounded-lg col-span-2" style={{ gridRow: 7 }}>
      <div className="w-1/4 mb-4 flex items-center p-4">
        <div className="text-gray-400 dark:text-gray-500 mr-2">
          #
        </div>
        <p className="font-bold text-xl dark:text-white"> Mentions</p>
      </div>

      <div>
        <EChartsReact option={option} style={{ width: '100%', height: mentionNames.length * 20 + 150 }} />
      </div>
    </div>
  )
})